angular.module('dpw.directives').directive('dpwLogPageView', ['trackUtil', function (trackUtil) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.on('click', function () {
                var pageName = attrs['dpwLogPageView'];
                trackUtil.logPageView(pageName);
            });
        }
    };
}]);